<template>
  <div class="mt-4">
    <div class="table-container" v-if="$store.state.appConfig.windowWidth >= 769">
      <div v-if="$store.state.modernDatabase.sampleDetail === null">
        <table class="sample-table header">
          <thead>
            <tr>
              <th scope="col" class="pop-col">{{$tI('Population column title')}}</th>
              <th scope="col" class="detail-col">{{$tI('Details column title')}}</th>
            </tr>
          </thead>
        </table>
        <div class="table-wrapper cs-scroll-style">
          <table class="sample-table">
            <tbody class="cs-scroll-style">
              <tr v-for="item in popList" :key="item.id">
                <td class="pop-col">{{$t(item.title.replaceAll('*', ' '))}}</td>
                <td class="detail-col">
                  <span class="table-action table-action-edit lab-p-8" @click="openDetail(item)" 
                    v-click-track="'Iframe.ancientDnaSampleDatabaseDetailsButtonClicked'">
                    <TableDetailIcon />
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <ModernSampleDetail v-else/>
    </div>

    <div v-else>
      <div class="encyclopedia-mobile">
        <div v-for="(item, index) in popList" :key="index">
          <div class="encyclopedia-mobile-item dashboard-card">
            <div>
              <div class="mobile-item-top">
                <div class="item-info left-info">
                  <h5>{{$tI('Population column title')}}</h5>
                  <h6>{{$t(item.title.replaceAll('*', ' '))}}</h6>
                </div>
              </div>
            </div>
            <div class="mobile-encyclopedia-icon">
              <span class="cursor-pointer" @click="openDetailMobile(item, index)"
                v-click-track="'Iframe.ancientDnaSampleDatabaseDetailsButtonClicked'"> 
                <circle-plus-icon v-show="!item.isOpenDetail" className="encyclopedia"/>
                <circle-x-icon v-show="item.isOpenDetail" className="encyclopedia"/>
              </span>
            </div>
          </div>

          <ModernSampleDetailMobile v-if="$store.state.modernDatabase.sampleDetail && item.isOpenDetail" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableDetailIcon from '@/components/icons/TableDetailIcon.vue';
import CirclePlusIcon from '@/components/icons/CirclePlusIcon.vue';
import CircleXIcon from '@/components/icons/CircleXIcon.vue';

import ModernSampleDetail from './ModernSampleDetail.vue';
import ModernSampleDetailMobile from './ModernSampleDetailMobile.vue';

export default {
  components: {
    TableDetailIcon,
    CirclePlusIcon,
    CircleXIcon,

    ModernSampleDetail,
    ModernSampleDetailMobile,
  },
  data() {
    return {
    }
  },
  methods: {
    openDetail(item) {
      this.$store.state.modernDatabase.sampleDetail = item;
    },
    openDetailMobile(item, index) {
      item.isOpenDetail = !item.isOpenDetail;
      if (item.isOpenDetail) {
        this.$store.state.modernDatabase.sampleDetail = item;
      } else {
        this.$store.state.modernDatabase.sampleDetail = null;
      }

      this.popList.forEach((element, indexItem) => {
        if (indexItem != index) {
          element.isOpenDetail = false;
        }
      });
    },
  },
  computed: {
    popList() {
      return this.$store.getters['modernDatabase/getModernDatabaseList'];
    },
  },
  watch: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
</style>
